import { ReleasesReport } from '@/components/analytics/ReleasesReport.tsx'
import { Separator } from '@/components/ui/separator.tsx'

export const ProjectAnalyticsReleasesPage = () => {
  return (
    <>
      <h1 className="font-EN-KR-heading3-bold text-contents-primary">Releases Report</h1>
      <Separator className="mt-2.5 mb-4 bg-border-default-secondary" />
      <ReleasesReport />
    </>
  )
}
